import {
    Component, Input, Output, EventEmitter, QueryList, ContentChildren, AfterContentInit, ViewEncapsulation
} from '@angular/core';
import { CwStepperItemComponent as StepperItem } from './components/stepper-item/stepper-item.component';
import { StepperEventsService } from './services/stepper-events.service';
import { filter } from 'rxjs';

@Component({
    selector: 'cw-stepper',
    template: `
      <ul class="cw-md-stepper">
        <ng-content />
      </ul>
    `,
    styleUrls: [
        './stepper.component.scss'
    ],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class CwStepperComponent implements AfterContentInit {
    @Input()
    public activeStep!: string;

    @Input()
    public allowGoto!: boolean;

    @Input()
    public changedStep = new EventEmitter<any>();

    @Output()
    public stepperDone = new EventEmitter<any>();

    @ContentChildren(StepperItem)
    public items!: QueryList<StepperItem>;

    constructor(
        protected stepperEvents: StepperEventsService
    ) {
    }

    public ngAfterContentInit(): void {
        this.items
            .forEach(
                (item: StepperItem, i: number, items: StepperItem[]) => {
                    item.number = i + 1;
                    item.isFirst = (i === 0);
                    item.isLast = (i === items.length - 1);
                }
            );

        this.stepperEvents
            .nextTopic
            .subscribe(this.nextStep.bind(this));
        this.stepperEvents
            .prevTopic
            .subscribe(this.prevStep.bind(this));
        this.stepperEvents
            .gotoTopic
            .pipe(
                filter(() => this.allowGoto)
            )
            .subscribe(this.gotoStep.bind(this));

        setTimeout(() => {
            this.setActive(this.activeStep);
        });
    }

    public setActive(step?: string): void {
        if (this.items.length === 0) {
            return;
        }

        step = step || this.items.first.alias;
        this.items
            .forEach(
                (item: StepperItem) => {
                    item.active = (item.alias === step);
                }
            );
    }

    protected nextStep(alias: string): void {
        const items = this.items.toArray();
        const length = items.length;

        for (let i = 0; i < length; i++) {
            if (items[i].alias === alias) {
                items[i].hide(true);
                if (i === length - 1) {
                    this.stepperDone.emit();
                } else {
                    items[i + 1].show();
                }

                break;
            }
        }
    }

    protected prevStep(alias: string): void {
        const items = this.items.toArray();
        const length = items.length;

        for (let i = length - 1; i >= 0; i--) {
            if (items[i].alias === alias) {
                items[i].hide();
                if (i !== 0) {
                    items[i - 1].show();
                }

                break;
            }
        }
    }

    protected gotoStep(alias: string): void {
        this.setActive(alias);
    }
}
